export const FAQ_ERROR_MESSAGE = 'Erro ao buscar respostas.'
